import { render, staticRenderFns } from "./mobilePersonalMenu.vue?vue&type=template&id=721090a9&scoped=true"
import script from "./mobilePersonalMenu.vue?vue&type=script&lang=js"
export * from "./mobilePersonalMenu.vue?vue&type=script&lang=js"
import style0 from "./mobilePersonalMenu.vue?vue&type=style&index=0&id=721090a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721090a9",
  null
  
)

export default component.exports